import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import { API_URL } from "url";
import { Typography } from "@mui/material";
import { setAuthSession, getDefaultRouteForScope } from "utils/auth";
function Basic() {
  const navigate = useNavigate();
  const [user, setAddUser] = useState({
    email: "",
    password: "",
  });
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [error, setErroer] = useState("");

  const handleChange = (e) => {
    e.preventDefault();
    const filedName = e.target.name;
    const filedValue = e.target.value;

    setAddUser({ ...user, [filedName]: filedValue });
  };
  const submitData = async (event) => {
    event.preventDefault();

    if (!user.email || !user.password) {
      setErroer("Fill all fields");
      return;
    }
    setErroer("");
    setSubmitButtonDisabled(true);
    try {
      const response = await fetch(API_URL + "/auth/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
      });
      const data = await response.json();

      if (data.sucess) {
        const targetRoute = getDefaultRouteForScope("admin");
        setAuthSession({
          token: data?.accessToken,
          user: data?.data?.email,
          scope: "admin",
          role: "admin",
        });
        navigate(targetRoute);
        window.location.href = targetRoute;
      } else {
        setErroer(data?.error);
        console.error("Error fetching data:", data);
      }
    } catch (error) {
      setErroer(error?.error);
      console.error("Fetch error:", error);
    } finally {
      setSubmitButtonDisabled(false);
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                placeholder="Email"
                style={{ height: "50px" }}
                name="email"
                value={user.email}
                onChange={handleChange}
              ></input>
            </MDBox>
            <MDBox mb={2}>
              <input
                type="password"
                placeholder="Password"
                className="form-control "
                id="exampleInputPassword1"
                style={{ height: "50px" }}
                name="password"
                value={user.password}
                onChange={handleChange}
              ></input>
              <Link to={"/forgotPassword"} aria-label="go to forgotPassword page">
                <Typography sx={{ fontSize: "14px" }}>Forgot Passsword</Typography>
              </Link>
            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={submitData}
                disabled={submitButtonDisabled}
              >
                Sign in
              </MDButton>
            </MDBox>
            {/* <MDBox mt={2} textAlign="center">
              <Link to="/hr-login" aria-label="go to hr login page">
                <Typography sx={{ fontSize: "14px" }}>HR sign in</Typography>
              </Link>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <p style={{ color: "red" }}>{error && error}</p>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
